import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import Box from '@zenbusiness/zui/Box';
import superstyled from '@zenbusiness/zui/styles/superstyled';
import Text from '@zenbusiness/zui/Text';

export const GroupContainer = superstyled({
  name: 'ThreadDateGroup',
  slot: 'Container',
  tag: Box,
  styles: ({ theme }) => ({
    marginBottom: theme.spacing(2)
  })
});

export const GroupHeader = superstyled({
  name: 'ThreadDateGroup',
  slot: 'Header',
  tag: Box,
  propsNeeded: ['collapsible'],
  styles: ({ theme, collapsible }) => ({
    display: 'flex',
    alignItems: 'center',
    opacity: 0.8,
    justifyContent: 'space-between',
    padding: `${theme.spacing(1)} ${theme.spacing(1.5)}`,
    cursor: collapsible ? 'pointer' : 'default',
    borderRadius: theme.shape.borderRadius,
    transition: 'background-color 0.2s ease-in-out',
    color: theme.palette.text.white,
    ...(collapsible &&
      {
        // '&:hover': {
        //   backgroundColor: 'rgba(255,255,255,0.1)' // theme.palette.action.hover
        // },
        // '&:focus': {
        //   outline: `2px solid ${theme.palette.primary.main}`,
        //   outlineOffset: '2px'
        // }
      })
  })
});

export const GroupLabel = superstyled({
  name: 'ThreadDateGroup',
  slot: 'Label',
  tag: Text,
  styles: () => ({
    flex: 1
  })
});

export const GroupMeta = superstyled({
  name: 'ThreadDateGroup',
  slot: 'Meta',
  tag: Box,
  styles: ({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1)
  })
});

export const ExpanIcon = superstyled({
  name: 'ThreadDateGroup',
  slot: 'ExpanIcon',
  tag: ExpandMoreIcon,
  propsNeeded: ['isExpanded'],
  styles: ({ isExpanded }) => ({
    // fontSize: '10px',
    // color: theme.palette.text.white,
    transition: 'transform 0.2s ease-in-out',
    transform: isExpanded ? 'rotate(0deg)' : 'rotate(-90deg)',
    transformOrigin: 'center',
    lineHeight: 1,
    userSelect: 'none'
  })
});

export const GroupContent = superstyled({
  name: 'ThreadDateGroup',
  slot: 'Content',
  tag: Box,
  propsNeeded: ['isExpanded'],
  styles: ({ theme, isExpanded }) => ({
    overflow: 'hidden',
    transition: 'all 0.3s ease-in-out',
    maxHeight: isExpanded ? '1000px' : '0',
    opacity: isExpanded ? 1 : 0,
    marginTop: isExpanded ? theme.spacing(1) : 0
  })
});

export const ThreadList = superstyled({
  name: 'ThreadDateGroup',
  slot: 'ThreadList',
  tag: Box,
  styles: ({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0)
  })
});
